// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/workdoc/WorkDoc.css
// module id = 119
// module chunks = 0